import React, { useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  login,
  loginPage,
  setToken,
  getMobile,
  getUser,
} from "../../Redux/Actions/Authentication";
import {
  Input,
  LoginHeader,
  onClickLogin,
  onClickSendCode,
} from "./LoginComponents";

function Login({ loginClose, login, setToken, getMobile, getUser }) {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [code, setCode] = useState("");
  const [, setSentCode] = useState("");
  const [, setPhoneIsValid] = useState(true);
  const [isCodeInput, setIsCodeInput] = useState(false);
  const [error, setError] = useState("");

  const resetInput = () => {
    setIsCodeInput(false);
    setPhoneNumber("");
    setCode("");
    setSentCode("");
    setPhoneIsValid(true);
    setError(false);
  };

  const onTextChange = (value) => {
    if (isCodeInput) return setCode(value);
    else return setPhoneNumber(value);
  };
  let history = useHistory();
  const dispatch = useDispatch();
  return (
    <div className="LoginContainer">
      <div className="Login">
        <LoginHeader loginClose={loginClose} />
        <Input
          setCodeInput={resetInput}
          isCodeInput={isCodeInput}
          onTextChange={onTextChange}
          error={error}
          onClickSendCode={() =>
            onClickSendCode(
              setError,
              setIsCodeInput,
              phoneNumber,
              setPhoneIsValid,
              setSentCode,
              getMobile
            )
          }
          onClickLogin={() =>
            onClickLogin(
              loginClose,
              login,
              code,
              phoneNumber,
              setToken,
              getMobile,
              getUser
            )
          }
        />
        <span
          className="pointer"
          onClick={() => {
            dispatch(loginPage(false));
            history.push({
              pathname: "terms",
            });
          }}
        >
          مشاهده قوانین و مقررات
        </span>
      </div>
    </div>
  );
}

const mapDispatchToProps = (dispatch) => ({
  getUser: (userInfo) => dispatch(getUser(userInfo)),
  getMobile: (phoneNumber) => dispatch(getMobile(phoneNumber)),
  loginClose: () => dispatch(loginPage(false)),
  setToken: (token) => dispatch(setToken(token)),
  login: () => dispatch(login(true)),
});

export default connect(null, mapDispatchToProps)(Login);
